var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.27815V4.99999C13 2.24317 10.7568 0 7.99998 0C5.24316 0 2.99999 2.24317 2.99999 4.99999V6.27815C2.40509 6.62502 2 7.2629 2 8V14C2 15.103 2.89696 16 3.99998 16H12C13.103 16 14 15.103 14 14V8C14 7.26287 13.5949 6.62499 13 6.27815ZM7.99998 1.99998C9.65428 1.99998 11 3.34567 11 4.99999V5.99998H4.99998V4.99999C4.99998 3.3457 6.34569 1.99998 7.99998 1.99998ZM8.99998 11.6107V13H6.99999V11.6107C6.69517 11.3362 6.5 10.9425 6.5 10.5C6.5 9.67155 7.17155 8.99999 7.99998 8.99999C8.82842 8.99999 9.49997 9.67155 9.49997 10.5C9.49997 10.9425 9.3048 11.3362 8.99998 11.6107Z",
    fill: "#7D8387"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock4);
export default __webpack_public_path__ + "static/media/lock4.9a5aca98d9b5edfa698a4c344591db21.svg";
export { ForwardRef as ReactComponent };